import { PointReviewItem } from 'components/point-review-item';
import { RewardReviewItem } from 'components/reward-review-item';
import ArticlePlaceholder from 'components/ui/article-placeholder';
import Box from 'components/ui/box';
import { useEffect, useState } from 'react';
import { RiArrowLeftSLine } from 'react-icons/ri';
import { getMissaoGestor, getMissaoEquipe } from 'services/achievement.service';
import { getKPIHistory, getKPIPublicHistoryByTime, getPlayerInfo } from 'services/dashboard.service';
import { getPublicProfile } from 'services/profile.service';
import Avatar from 'funifier-nice-avatar';
import MissaoDestaquePorUsuario from 'components/MissaoDestaque';
import Button from 'components/ui/button';
import ChangeGestor from './ChangeGestor';
import { User } from 'types/user';
import CustomSelect from 'components/custom-select';
import { useAuth } from 'context/AuthContext';
import Humanograma from 'components/Humanograma';

interface MinhaEquipeDetailProps {
  id?: string;
  isFromTeam: boolean;
  onClose: () => void;
}
export function MinhaEquipeDetail({ id, onClose, isFromTeam }: MinhaEquipeDetailProps) {
  const { user, realCycle } = useAuth();

  const [realCycleFilter, setRealCycleFilter] = useState<any>();
  const [selectedUser, setSelectedUser] = useState<User>();
  const [userInfo, setUserInfo] = useState<any>();
  const [activeTab, setActiveTab] = useState<number>(0);
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(true);

  const [list, setList] = useState<unknown[]>();
  const [missionList, setMissionList] = useState<unknown[]>();

  useEffect(() => {
    if (!id || !realCycle) return;

    async function loadPlayerInfo() {
      const userProfile = await getPublicProfile(id as string);
      const playerInfo = await getPlayerInfo(id as string);
      setUserInfo(playerInfo);
      setSelectedUser(userProfile);

      const item = (realCycle as any[])[0];
      setRealCycleFilter({
        label: item.title,
        value: item._id,
      });
    }

    // async function loadRealizacoes() {
    //   if (!id || !selectedUser || !userInfo || !realCycleFilter) return;

    //   setLoading(true)

    //   const isGestor = userInfo?.tipo_ro === 'GERENCIAL' || userInfo?.funcao === 'DIRETOR';

    //   if (isGestor) {
    //     const dataGestor = await getMissaoGestor(id);
    //     const dataEquipe = await getMissaoEquipe(id);
    //     setMissionList([...dataGestor, ...dataEquipe]);
    //   } else {
    //     const data = await getMissaoEquipe(id);
    //     setMissionList(data);
    //   }

    //   setLoading(false);
    // }

    async function loadReconhecimentos() {
      if (!id || !selectedUser || !userInfo || !realCycleFilter) return;

      setLoading(true);

      const result = await getKPIPublicHistoryByTime(id, null, null, realCycleFilter.value);
      setList(result.filter((x: any) => !x.cancelled));
      setLoading(false);
    }

    if (!selectedUser || !userInfo) {
      loadPlayerInfo();
    }

    // if (activeTab === 1) {
    //   loadRealizacoes();
    // } else if (activeTab === 0) {
    if (activeTab === 0) {
      loadReconhecimentos();
    }
  }, [id, activeTab, selectedUser, userInfo, realCycle, realCycleFilter]);

  return (
    <div className="mx-auto container p-3 lg:p-10">
      <div className="flex justify-between items-center space-x-3 lg:space-x-2 mb-3 lg:mb-10">
        <div className="flex items-center">
          <div className="cursor-pointer" onClick={() => onClose()}>
            <button className="rounded-full bg-purple flex justify-center items-center p-1">
              <RiArrowLeftSLine size={28} className="text-white" />
            </button>
          </div>
          <h1 className="text-lg lg:text-3xl py-1 px-6">Perfil de {selectedUser?.name}</h1>
        </div>

        {!!isFromTeam && (
          <div>
            <Button className="px-6 py-2 uppercase" color="primary" onClick={() => setShowModal(true)}>
              Alterar Gestor
            </Button>
          </div>
        )}
      </div>

      {userInfo && (
        <div className="flex flex-row items-center space-x-3 mb-5">
          <div className="w-32 h-32 md:w-44 md:h-44 bg-purple flex items-center justify-center rounded-full overflow-hidden text-3xl md:text-6xl">
            {!!selectedUser?.extra.avatar_type &&
              (selectedUser.image ? (
                <img src={selectedUser.image.medium.url} alt={selectedUser.name} className="w-full h-full" />
              ) : (
                selectedUser.name[0]
              ))}
            {!selectedUser?.extra.avatar_type &&
              (!!selectedUser?.extra.avatar ? (
                <Avatar className="w-full h-full" {...selectedUser.extra.avatar} />
              ) : (
                selectedUser?.name[0]
              ))}
          </div>
          <div className="space-y-3">
            <Humanograma data={{ ...userInfo, _id: userInfo?.chave }}>
              <div className="text-lg md:text-2xl text-white text-center font-bold">
                {selectedUser?.name} <span className="font-thin">({selectedUser?._id})</span>
              </div>
            </Humanograma>
            {userInfo && (
              <div className="md:text-xl font-thin">
                <span>{userInfo?.grupo?.nome}</span> <span>({userInfo?.grupo?.total} funci)</span>{' '}
                <span className="font-bold text-md p-1 px-4 rounded-2xl bg-maastricht-blue text-electric-blue">
                  {userInfo?.ro}
                </span>
              </div>
            )}
          </div>
        </div>
      )}

      <div className="w-full flex flex-col space-y-5 mt-10">
        <div className="rounded-xl overflow-hidden  items-center justify-between mb-12 flex">
          <button
            className={`${
              activeTab === 0 ? 'bg-slate-blue' : 'bg-maastricht-blue'
            } ${!user?.extra.rede ? 'w-6/12' : 'w-full'} h-[86px] text-2xl text-white border-0 font-semibold flex items-center justify-center`}
            onClick={() => setActiveTab(0)}
          >
            Reconhecimentos recebidos
          </button>
          {!user?.extra.rede && (
            <button
              className={`${
                activeTab === 1 ? 'bg-slate-blue' : 'bg-maastricht-blue'
              } w-6/12 h-[86px] text-2xl text-white border-0 font-semibold flex items-center justify-center`}
              onClick={() => setActiveTab(1)}
            >
              Participação em Realizações Destaque
            </button>
          )}
        </div>

        {activeTab === 0 && (
          <>
            <Box>
              <div className="space-y-5 lg:p-3">
                <div className="flex items-center justify-between">
                  <h3 className="text-2xl">
                    Reconhecimentos recebidos <b className="text-yellow">{list ? `(${list?.length})` : null}</b>
                  </h3>

                  <div className="w-full lg:w-[264px]">
                    {!!realCycle && !!realCycleFilter && (
                      <CustomSelect
                        value={realCycleFilter}
                        placeholder="Clique para selecionar o ciclo"
                        options={realCycle?.map((item: any, index: number) => {
                          return {
                            label: item.title,
                            value: item._id,
                          };
                        })}
                        onChange={(e: any) => [setRealCycleFilter(e)]}
                      />
                    )}
                  </div>
                </div>

                {loading ? (
                  <div className="space-y-2">
                    <ArticlePlaceholder />
                    <ArticlePlaceholder />
                  </div>
                ) : null}

                {!loading && list?.length ? (
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    {list?.map((item: any) => <RewardReviewItem data={item} key={item._id} />)}
                  </div>
                ) : null}

                {!loading && !list?.length ? (
                  <div className="py-8 flex items-center justify-center">
                    <p>Não existem reconhecimentos para o ciclo selecionado.</p>
                  </div>
                ) : null}
              </div>
            </Box>
          </>
        )}

        {activeTab === 1 && !!id && <MissaoDestaquePorUsuario id={id} isFromTeam={!!isFromTeam} />}
      </div>

      {showModal && !!selectedUser && (
        <ChangeGestor
          player={selectedUser}
          closeModal={() => setShowModal(false)}
          onSubmit={() => {
            setShowModal(false);
            onClose();
          }}
        />
      )}
    </div>
  );
}
